//CRN_20260728 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';
import { WebhookLogDTO } from 'src/app/core/models/system/webhook/webhook-log.dto';

@Injectable({ providedIn: 'root' })

export class WebhookLogService {

  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public getForCompany(companyId: number): Observable<WebhookLogDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;

                            return <Observable<WebhookLogDTO[]>>this.httpClientService.get<WebhookLogDTO[]>(
                                   environment.eSimApi
                                   + eSimApiPaths.WebhookLog
                                   + "/"
                                   + eSimApiPaths.WebhookLogForCompany
                                   + "/"
                                   + companyIdEncSS);
                         })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
